export const SERVICE_UNAVAILABLE_MESSAGE = 'Service is temporarily unavailable. Please try again shortly.';

const SERVICE_UNAVAILABLE_CODE = '0x02FF04';

// error_code can appear either on the response envelope directly or nested under its `data` payload,
// depending on the endpoint, so both locations are checked.
export const isServiceUnavailable = (data: unknown): boolean => {
    if (!data || typeof data !== 'object') return false;
    const envelope = data as { error_code?: string | number; data?: { error_code?: string | number } };
    return envelope.error_code === SERVICE_UNAVAILABLE_CODE || envelope.data?.error_code === SERVICE_UNAVAILABLE_CODE;
};
